import { RootState } from '../rmsStore';

export function getGlobalReducer(state: RootState): GlobalDataState {
  return state.globalReducer;
}

